<template>
	<v-container>
		<div class="about">
        	<h1>This is an about page</h1>
  		</div>
  		  <h3>{{ title }}</h3> 
		  <button @click="title='New Title'">Update Title</button>
		  <button @click="destroy()">Destroy</button>
	</v-container>
    
</template>
<script>
	export default {
		data () {
			 return {
			 	title: 'Hello Vue!',
			 }
		},
		beforeCreate: function() {
		     console.log("beforeCreate()")
	  },
	  created: function() {
	    console.log("created()")
	  },
	  beforeMount: function() {
	    console.log("beforeMount()");
	  },
	  mounted: function() {
	    setTimeout(function(){console.log("mounted()")}, 3000);
	  },
	  beforeUpdate: function() {
	    console.log("beforeUpdate()")
	  },
	  updated: function() {
	    console.log("updated()")
	  },
	  beforeDestroy: function() {
	    console.log("beforeDestroy()")
	  },
	  destroyed: function() {
	    console.log("destroyed()")
	  },
	  methods: {
	    destroy: function() {
	      this.$destroy();
	    }
	  }

	}
</script>